import {
  Button,
  ButtonVariant,
  ColorClass,
  Icon,
  IconIdentifier,
} from '@aus-platform/design-system';
import React from 'react';

type DrillAndBlastHistoryEmptyListProps = {
  onClickGenerateFromHistory: VoidFunction;
};

export const DrillAndBlastHistoryEmptyList: React.FC<
  DrillAndBlastHistoryEmptyListProps
> = ({ onClickGenerateFromHistory }) => {
  return (
    <div className="drill-and-blast__container__history-empty">
      <Icon
        identifier={IconIdentifier.DrillAndBlast}
        colorClass={ColorClass.Neutral250}
        size={72}
      />
      <p className="drill-and-blast__container__history-empty-text">
        You haven't generated any drill and blast requests yet. Generate a
        request to view it here.
      </p>
      <Button
        variant={ButtonVariant.Primary}
        onClick={onClickGenerateFromHistory}
      >
        Generate Request
      </Button>
    </div>
  );
};
